import React from 'react';
import { IAdvantageCommunicationModuleProps, ILinkProps } from '../../../interfaces/interfaces';
import Link from '../../elements/Link/Link';
import { ModalContextConsumer } from '../../../contexts/modalContext';
import ModalHelpers from '../../../helpers/ModalHelpers/ModalHelpers';

function AdvantageCommunicationModule(props: IAdvantageCommunicationModuleProps & ILinkProps): JSX.Element {
  const { headline, advantageList, personalisationText } = props;

  return (
    <div className="tile-padding">
      <h2 className="hl-2">{headline}</h2>
      {/* eslint-disable-next-line react/no-danger */}
      <ul className="tile-list" dangerouslySetInnerHTML={{ __html: advantageList || '' }} />
      <ModalContextConsumer>
        {({ openModal }) => (
          <Link
            onClick={() => {
              ModalHelpers.openPersonalisation(openModal);
            }}
            linkHref="#"
            linkText={personalisationText}
            linkClass="link--button ic-arrowRight"
          />
        )}
      </ModalContextConsumer>
    </div>
  );
}
export default AdvantageCommunicationModule;
